var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isToken === false)?_c('recovery-invalid-token'):(_vm.loading === true)?_c('recovery-validation-in-progress'):(_vm.tokenValid === false)?_c('recovery-invalid-token'):_c('recovery-password-form',{attrs:{"token":_vm.token}})}
var staticRenderFns = []

export { render, staticRenderFns }